module.exports = __webpack_public_path__ + "img/guarantee.01810de5.svg";